import { createSlice } from '@reduxjs/toolkit';

import { AdminInquiryDetails } from '@models/adminInquiries';

import { handleGetAdminInquiryList } from './actions';
import { IAdminInquiryListState } from './slice.interface';

const initialState: IAdminInquiryListState = {
  data: null,
  isLoading: false,
  error: false,
};

export const inquiryListSlice = createSlice({
  name: 'admin-inquiry-list',
  initialState,
  reducers: {
    removeAdminSearchInquiries: state => {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminInquiryList.pending, (state: IAdminInquiryListState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAdminInquiryList.rejected, (state: IAdminInquiryListState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAdminInquiryList.fulfilled, (state: IAdminInquiryListState, action) => {
        state.data = {
          ...action.payload.data,
          tableData: Array.isArray(action.payload.data?.tableData)
            ? action.payload.data.tableData.map(item => new AdminInquiryDetails(item))
            : [],
        };
        state.isLoading = false;
      });
  },
});

export const { removeAdminSearchInquiries } = inquiryListSlice.actions;

export default inquiryListSlice.reducer;
